import { Pipe, PipeTransform } from '@angular/core';
let moment = require("moment")
@Pipe({ name: 'stringDate' })
export class StringDatePipe implements PipeTransform {
	transform(value: string, args: string[] = []): any {
		if (!value) return "";
		let date: any = moment(value, "YYYY-MM-DD'T'HH:mm:ss")
		return date.format("DD.MM.YYYY HH:mm")

	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/string-date.pipe.ts